// initial state
const state = {
  stash: {
    publication: [],
    patent: [],
  },
};

const getters = {
  // Return state of stash
  getStash: (state) => {
    return state.stash;
  },
};

const actions = {
  // Add one or more items to stash
  addToStash({ commit, state, rootGetters }, payload) {
    // Get the stash source from the payload, if not present, use the active data source
    const source =
      payload && payload.source
        ? payload.source
        : rootGetters['app/activeDataSource'];
    // Get the stash for the source
    const stash = state.stash[source];

    // Look for item from payload in the stash, if already in the stash, don't add again
    if (stash.length > 0) {
      const item = payload.item;
      const i = stash.findIndex((stashItem) => {
        return stashItem.id === item.id;
      });
      if (i < 0) {
        // This item is not in the stash -- Add it to the stash
        commit('addToStash', { source, item });
      }
    } else {
      // No stash items exist, add payload to stash
      commit('addToStash', { source, item: payload.item });
    }
  },
  // Remove one item from stash
  removeItemFromStash({ commit, state }, payload) {
    // Get the stash source from the payload
    const { source } = payload;

    if (source) {
      // Get the stash array for the source
      const stash = state.stash[source];
      // Find the index of the item in the stash to be removed
      const i = stash.findIndex((stashItem) => {
        return stashItem.id === payload.id;
      });
      if (i >= 0) {
        // Item index was found -- commit mutation to remove it from the stash
        // Pass in the stash source and the index value of the item to be removed
        commit('removeItemFromStash', { source, index: i });
      }
    }
  },
  // Clear all items from stash for a given source
  clearStash({ commit }, source) {
    commit('clearStash', source);
  },
};

// mutations
const mutations = {
  addToStash(state, payload) {
    const { source, item } = payload;
    state.stash[source].push(item);
  },
  removeItemFromStash(state, payload) {
    const { source, index } = payload;
    // Remove item at index i from the stash
    state.stash[source].splice(index, 1);
  },
  clearStash(state, source) {
    state.stash[source] = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
